import { Property } from "@/features/survey/types";
import { useState } from "react";
import PropertyMenuItem from "./PropertyMenuItem";

interface MobilePropertiesMenuProps {
  surveyId: string;
  properties: Property[];
  allProperties?: Property[];
  isActive?: boolean;
  showShortlistOnly?: boolean;
  onItemClick?: () => void;
}

const MobilePropertiesMenu = ({
  surveyId,
  properties,
  allProperties = [],
  isActive = false,
  showShortlistOnly = false,
  onItemClick,
}: MobilePropertiesMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const emptyMessage = showShortlistOnly
    ? "No shortlisted properties found"
    : "No properties available";

  const handleItemClick = () => {
    setIsOpen(false);
    onItemClick?.();
  };

  return (
    <div>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors flex items-center justify-between ${
          isActive
            ? "text-white underline font-semibold"
            : "text-gray-200 hover:text-green-300"
        }`}
      >
        <span>Properties</span>
        <svg
          className={`w-4 h-4 transition-transform ${isOpen ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="ml-4 mt-1 space-y-1 max-h-80 overflow-y-auto">
          {properties.length > 0 ? (
            properties.map((property) => (
              <PropertyMenuItem
                key={property.id}
                property={property}
                surveyId={surveyId}
                properties={allProperties}
                onClick={handleItemClick}
                variant="mobile"
              />
            ))
          ) : (
            <div className="px-3 py-2 text-sm text-gray-400 text-center">
              {emptyMessage}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MobilePropertiesMenu;
